<p-dialog [(visible)]="display" [modal]="true" appendTo="body" [style]="{width: '25vw'}" (onHide)="cancel()">
  <ng-template pTemplate="header">
    {{'widgets.activity-graphs.hour-graph.title' | translate}}

    <a (click)="clearDefault()" class="btn btn-default btn-sm pull-right"
      pTooltip="{{'widgets.party-activities.filter' | translate}}">
      <i class="fa fa-filter text-danger" aria-hidden="true"></i>
    </a>
  </ng-template>
  <div class="modal-body">
    <div class="row form-group">
      <label for="note" class="col-form-label col-form-label-sm col-lg-4">
        <strong>{{ 'widgets.party-activities.period' | translate }}</strong>
      </label>
      <div class="col-lg-8">
        <p-dropdown [options]="periodOptions" [(ngModel)]="data" optionLabel="name" optionValue="value" appendTo="body">
        </p-dropdown>
      </div>
    </div>
    <div class="form-group row">
      <label for="note" class="col-form-label col-form-label-sm col-lg-4">
        <strong> {{ 'widgets.party-activities.typology' | translate }} </strong>
      </label>
      <div class="col-lg-8">
        <p-multiSelect [options]="typologyList" [(ngModel)]="selectedTypologies" optionLabel="name" appendTo="body"
          optionValue="id" [maxSelectedLabels]="1"
          placeholder="{{ 'widgets.party-activities.select-typology' | translate }}"
          selectedItemsLabel="{0} {{ 'widgets.party-activities.selected-typology' | translate }}">
        </p-multiSelect>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" data-dismiss="modal" (click)="cancel()">
        {{ 'app.cancel' | translate }}
      </button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="confirm()">
        {{ 'app.confirm' | translate }}
      </button>
    </div>
  </p-footer>
</p-dialog>
